import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { Button } from "@atoms/links"
import { Container, Section } from "@atoms/layout"

const Pagination = ({ pageContext }) => {
  const { previousPagePath, nextPagePath } = pageContext

  return (
    <Section md>
      <Container>
        <Nav>
          {previousPagePath && (
            <PathLink to={`${previousPagePath}`}>
              <Button>Newer Posts</Button>
            </PathLink>
          )}
          {nextPagePath && (
            <PathLink to={`${nextPagePath}`}>
              <Button>Older Posts</Button>
            </PathLink>
          )}
        </Nav>
      </Container>
    </Section>
  )
}

export default Pagination

const Nav = styled.nav`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`

const PathLink = styled(Link)`
  margin: 0 1rem;
`
